import { addLoader, ajaxRequest, removeLoader } from '../../services/ajax-service';
import { historyNavigation, scrollUp } from './handlers';
import { initVueApps, VUE_INITIALIZED_APP_SELECTOR } from '../vue-global-initializer';
import { initCustomSelect } from '../custom-select';

// eslint-disable-next-line import/no-cycle
import { SmartFilter } from './Smart-Filter';
import {
    EVENT_FILTER_APPLIED,
    EVENT_FINISH_LOAD_CATALOG,
    EVENT_START_LOAD_CATALOG,
} from '../../services/event-bus/event-types';

const { eventBus } = window.specialtyApp;

export class Request {
    constructor() {
        this.REQUEST_URL = './';

        this.filterLocation = document.getElementById('smartfilter');
        this.resultLocation = document.getElementById('filter-result');
        this.paginationLocation = document.getElementById('pagination');

        this.query = null;
        this.previusFormData = [];

        this.init();

        this.isLoading = false; // для предотвращения задвоения запроса
    }

    init = () => {
        historyNavigation();
    };

    async request(formData = {}) {
        const queryArray = Array.from(formData);
        const previousQueryArray = Array.from(this.previusFormData);
        const { searchParams } = new URL(window.location);

        // Если в предыдущем запросе был, а сейчас нет, удаляем
        previousQueryArray.forEach((item) => {
            const key = item[0];
            // console.log('key', key);
            // console.log(!queryArray.includes(key));
            searchParams.delete(key);
        });

        queryArray.forEach((item) => {
            const key = item[0];
            let value = item[1];

            if (key.match(/MIN/) || key.match(/MAX/)) {
                // Нужно форматнуть число
                value = value.replaceAll(' ', '');
            }

            searchParams.set(key, value);
        });

        // console.log(Array.from(searchParams));

        // this.clearSearch();
        setTimeout(() => addLoader(this.filterLocation), 0);
        addLoader(this.resultLocation);
        scrollUp();

        this.query = searchParams;

        const query = new FormData();
        Array.from(searchParams).forEach((item) => {
            const key = item[0];
            const value = item[1];

            query.append(key, value);
        });

        eventBus.$emit(EVENT_START_LOAD_CATALOG);
        await ajaxRequest(this.REQUEST_URL, { query })
            .then((response) => this.successHandler(response))
            .catch((error) => console.log(error.message))
            .finally(() => {
                eventBus.$emit(EVENT_FINISH_LOAD_CATALOG);
                removeLoader(this.filterLocation);
                removeLoader(this.resultLocation);
                this.previusFormData = formData;
            });
    }

    /**
     * "простой" запрос по строке параметров, применяется при фильтрации по лабораториям
     * @param {string} queryString
     * @return {Promise<void>}
     */
    async requestSimple(queryString) {
        if (this.isLoading) return;
        this.isLoading = true;

        setTimeout(() => addLoader(this.filterLocation), 0);
        addLoader(this.resultLocation);
        scrollUp();

        eventBus.$emit(EVENT_START_LOAD_CATALOG);
        const requestUrl = `${this.REQUEST_URL}${queryString}`;

        await ajaxRequest(requestUrl, { type: 'GET' })
            .then((response) => {
                const data = response?.data;
                if (!data) {
                    console.log('Фильтр пустой'); // TODO: обработать
                    return;
                }

                const { filter, items, pagination } = JSON.parse(data);

                this.renderResult(filter, items, pagination);
                window.history.pushState({}, '', `${queryString}`);
                eventBus.$emit(EVENT_FILTER_APPLIED);
            })
            .catch((error) => console.log(error.message))
            .finally(() => {
                eventBus.$emit(EVENT_FINISH_LOAD_CATALOG);
                this.isLoading = false;
                removeLoader(this.filterLocation);
                removeLoader(this.resultLocation);
            });
    }

    successHandler(response) {
        if (!{}.hasOwnProperty.call(response, 'data')) {
            throw new Error('Нет данных для отрисовки результата');
        }

        const { data } = response;

        if (!data) {
            console.log('Фильтр пустой'); // TODO: обработать
            return;
        }

        const { filter, items, pagination } = JSON.parse(data);

        this.renderResult(filter, items, pagination);
        this.setSearchURL();
    }

    renderResult(filter, items, pagination) {
        try {
            if (!items) { // пустой результат
                // FIXME:
                // при пустом фильтре, разметка приходит с бека
                // это так, на непредвиденный случай
                const col12 = document.createElement('div');
                col12.classList.add('col-12');

                const empty = document.createElement('div');
                empty.classList.add('filter-result__empty');
                empty.innerHTML = 'Не найдено товаров точно соответствующих запросу.<br>Измените параметры.';

                col12.appendChild(empty);

                this.resultLocation.textContent = '';
                this.resultLocation.appendChild(col12);
                return;
            }

            if (filter) {
                this.filterLocation.innerHTML = filter;

                // eslint-disable-next-line no-unused-vars
                const smartFilter = new SmartFilter(this.filterLocation);
                smartFilter.initRelations();
            }

            // нормальный результат выдачи
            this.resultLocation.innerHTML = items;
            this.paginationLocation.innerHTML = pagination;

            this.reloadNotificationHandler();
            initVueApps();
            initCustomSelect();
        } catch (e) {
            console.log(e.message);
        }
    }

    setSearchURL() {
        let isClearURL = false;

        if (!this.query) {
            window.history.pushState({}, '', './');
            eventBus.$emit(EVENT_FILTER_APPLIED);
            return;
        }

        Array.from(this.query).forEach((item) => {
            const key = item[0];

            if (key === 'del_filter') {
                this.query.delete(key);
                this.query = null;
                this.previusFormData = [];
                isClearURL = true;
            }
        });

        if (isClearURL) {
            window.history.pushState({}, '', './');
            eventBus.$emit(EVENT_FILTER_APPLIED);
            return;
        }

        const queryString = new URLSearchParams(this.query || {}).toString();
        window.history.pushState({}, '', (queryString.length ? `?${queryString}` : window.location.pathname));
        eventBus.$emit(EVENT_FILTER_APPLIED);
    }

    setInitPreviousFormData(formData) {
        this.previusFormData = formData;
    }

    reloadNotificationHandler = () => {
        // basket-notifications-handler
        const element = document.querySelector('.page__basket-popup');
        element.classList.remove(VUE_INITIALIZED_APP_SELECTOR.replace('.', ''));
        element.textContent = '';

        const vueNotificationHandler = document.createElement('basket-notifications-handler');
        element.appendChild(vueNotificationHandler);
    }
}
